export * from '@fhs/routing/src/routes/(tabs)/rewards/offers/_layout';
export { default } from '@fhs/routing/src/routes/(tabs)/rewards/offers/_layout';
